/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { JobRestService, JobSpecTemplateRestService } from '@gh/builder-shared-data';
import { AutocompleteItem } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { compact } from 'lodash';
import { JobSpecTemplateListItem } from './job-spec-create.model';

@Injectable()
export class JobSpecCreateBusinessService {
  constructor(private jobSpecTemplateRest: JobSpecTemplateRestService,
              private jobRest: JobRestService) {

  }

  findAllAsDataSource(query: FilteredDataQuery<string>): Observable<JobSpecTemplateListItem[]> {
    return this.jobSpecTemplateRest.findAllAsFinderDataSource({
      searchString: query.filter,
      showDeleted: false,
      isForRfq: false,
    }).select(query).pipe(map$(getSlicedData));
  }

  findAllJobs(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.jobRest.findAllAsAutocompleteDataSourceForFinder({
      showDpp: true,
      showActive: true,
      showFinalized: false,
      showNotProceeding: false,
      searchString: query.filter,
      isSpecExist: false,
    })
      .select(query).pipe(
        map$(getSlicedData),
        map$((jobs) => jobs.map((job) => ({
          id: job.id,
          name: job.jobNumber,
          isDpp: job.isDpp,
          description: job.siteAddress,
          display: compact([job.jobNumber, job.contactName, job.siteAddress]).join(' '),
        }))));
  }
}
